const X = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M22 5.90765C21.2504 6.23503 20.4565 6.44969 19.644 6.54465C20.4968 6.04388 21.138 5.24976 21.448 4.31065C20.64 4.78098 19.7587 5.11226 18.841 5.29065C18.4545 4.88586 17.9897 4.56404 17.4748 4.34483C16.9598 4.12562 16.4056 4.01362 15.846 4.01565C13.58 4.01565 11.743 5.82565 11.743 8.05565C11.743 8.37165 11.779 8.68065 11.849 8.97565C10.2236 8.89835 8.63212 8.48306 7.17617 7.75629C5.72022 7.02952 4.43176 6.00723 3.393 4.75465C3.02883 5.36905 2.83742 6.07043 2.839 6.78465C2.8397 7.45262 3.00683 8.10988 3.32529 8.69705C3.64375 9.28421 4.1035 9.78276 4.663 10.1477C4.01248 10.1267 3.37602 9.95298 2.805 9.64065V9.69065C2.805 11.6487 4.22 13.2817 6.095 13.6537C5.74261 13.7472 5.37958 13.7945 5.015 13.7947C4.75 13.7947 4.493 13.7697 4.242 13.7197C4.51008 14.5276 5.02311 15.232 5.70982 15.735C6.39653 16.238 7.22284 16.5147 8.074 16.5267C6.61407 17.6512 4.82182 18.2587 2.979 18.2537C2.647 18.2537 2.321 18.2337 2 18.1977C3.88125 19.3884 6.06259 20.0189 8.289 20.0157C15.836 20.0157 19.962 13.8587 19.962 8.51965L19.948 7.99665C20.7529 7.43032 21.4481 6.7225 22 5.90765Z"
      fill="currentColor"
    />
  </svg>
);

export default X;
